<template>
  <!-- 关于我们页面 -->
  <div>
    <!-- PC端 -->
    <div class="about_us" v-if="webFlag">
      <!-- 头部 -->
      <head-nav :selectedId="4"></head-nav>
      <img src="../assets/images/banner04.png" alt="" style="width: 100%" />
      <!-- 主体 -->
      <el-container>
        <el-aside width="100%">
          <title-com :name="'关于我们'" :letter="'ABOUT US'"></title-com>
          <el-row>
            <el-col :span="8">
              <el-menu default-active="/aboutUs" class="el-menu-demo">
                <el-menu-item
                  v-for="(item, i) in aboutUsList"
                  :key="i"
                  @click="eventHandle(i)"
                  :class="{ actived: is_active == i }"
                >
                  <ul>
                    <li>
                      <span class="point"></span>
                      <span>{{ item.text }}</span>
                      <img :src="is_active == i ? item.url : item.path" alt="" class="icon" />
                    </li>
                  </ul>
                </el-menu-item>
              </el-menu>
            </el-col>
            <el-col :span="2"></el-col>
            <el-col :span="14">
              <div>
                <introduce v-if="is_active == 0"> </introduce>
                <culture v-if="is_active == 1"></culture>
                <honor v-if="is_active == 2"></honor>
                <contact-us v-if="is_active == 3"></contact-us>
              </div>
            </el-col>
          </el-row>
        </el-aside>
      </el-container>
      <footer-com />
    </div>
    <!-- 移动端 -->
    <div class="about_us" v-if="mobilPhoneFlag">
      <!-- 头部 -->
      <mobileHead></mobileHead>
      <img
        src="../assets/images/banner04.png"
        alt=""
        style="width: 100%; margin: 44px 0"
      />
      <el-container>
        <el-aside width="100%">
          <title-com :name="'关于我们'" :letter="'ABOUT US'"></title-com>
          <div class="part">
            <div
              class="part-item"
              v-for="(item, i) in aboutUsList"
              :key="i"
              :class="{ actived: is_active == i }"
              @click="eventHandle(i)"
            >
              <img :src="is_active == i ? item.path : item.gray" alt="" />
              <p>{{ item.text }}</p>
            </div>
          </div>
          <div style="background: #fff; padding: 10px">
            <introduce v-if="is_active == 0"> </introduce>
            <culture v-if="is_active == 1"></culture>
            <honor v-if="is_active == 2"></honor>
            <contact-us v-if="is_active == 3"></contact-us>
          </div>
        </el-aside>
      </el-container>
      <mobile-footer></mobile-footer>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/header.vue";
import footerCom from "@/components/footer.vue";
import titleCom from "@/components/title.vue";
import introduce from "@/components/introduce.vue";
import culture from "@/components/culture.vue";
import honor from "@/components/honor.vue";
import contactUs from "@/components/contactUs.vue";
// 移动端组件
import mobileHead from "@/components/publicCom/mobileHead.vue";
import mobileFooter from "@/components/publicCom/mobileFooter.vue";
export default {
  components: {
    headNav,
    footerCom,
    titleCom,
    introduce,
    culture,
    honor,
    contactUs,
    mobileHead,
    mobileFooter,
  },
  data() {
    return {
      aboutUsList: [
        {
          id: 0,
          name: "introduce",
          text: "公司介绍",
          url: require("../assets/images/icon_about_introduce01.png"),
          path: require("../assets/images/icon_about_introduce02.png"),
          gray: require("../assets/images/icon_about_introduce03.png"),

        },
        {
          id: 1,
          name: "culture",
          text: "企业文化",
          url: require("../assets/images/icon_about_culture01.png"),
          path: require("../assets/images/icon_about_culture02.png"),
          gray: require("../assets/images/icon_about_culture03.png"),
        },
        {
          id: 2,
          name: "honor",
          text: "公司荣誉",
          url: require("../assets/images/icon_about_honor01.png"),
          path: require("../assets/images/icon_about_honor02.png"),
          gray: require("../assets/images/icon_about_honor03.png"),
        },
        {
          id: 3,
          name: "honor",
          text: "联系我们",
          url: require("../assets/images/icon_about_introduce01.png"),
          path: require("../assets/images/icon_about_introduce02.png"),
          gray: require("../assets/images/icon_about_introduce03.png"),
        },
      ],
      is_active: 0,
      webFlag: true,
      mobilPhoneFlag: false,
    };
  },
  mounted() {
    this.getScreenWidth();
  },
  methods: {
    // 获取当前设备宽度
    getScreenWidth() {
      console.log(document.body.offsetWidth, window.screen.availWidth);
      if (window.screen.availWidth <= 1366) {
        this.webFlag = false;
        this.mobilPhoneFlag = true;
        console.log(window.screen.availWidth);
      }
    },
    eventHandle(index) {
      this.is_active = index;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1367px) {
  .about_us {
    width: 100%;
    .el-container {
      margin: 40px 100px;
      .text {
        display: flex;
        justify-content: center;
        .line {
          width: 172px;
          height: 4px;
          background: #949494;
          position: relative;
          top: 45px;
        }
        .title {
          margin: 0 60px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #454545;
          .title_1 {
            font-size: 36px;
            margin-bottom: 10px;
          }
          .title_2 {
            font-size: 16px;
          }
        }
      }
      .el-menu {
        width: 80%;
        margin: 0 auto;
        .el-menu-item {
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          height: 80px;
          line-height: 80px;
          color: #454545;
          padding: 0;
          ul > li {
            list-style-type: square;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0;
          }
        }
        .actived {
          width: 100%;
          color: #fff;
          background: #3660d9;
        }
        .icon {
          width: 38px;
          height: 38px;
        }
        .point {
          width: 5px;
          height: 5px;
          background: #e0e0e0;
        }
      }
    }
  }
}
@media screen and (max-width: 1366px) {
  .el-container {
    width: 100%;
    .el-aside {
      margin: 0 auto;
    }
  }
  .part {
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin: 20px 0;
    .part-item {
      width: 20%;
      background: #fff;
      border-radius: 5px;
      padding: 10px 0;
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #454545;
      opacity: 0.8;
      img {
        width: 38px;
        height: 38px;
        margin-bottom: 7px;
      }
    }
  }
  .actived {
    color: #3660d9 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs.vue